import { motion, AnimatePresence } from 'framer-motion'
import { Sparkles, Award, Trophy, Star } from 'lucide-react'
import { useEffect, useState } from 'react'

function Toast({ message, points, type = 'points', isVisible, onHide }) {
  const [show, setShow] = useState(false)
  const [hasBeenVisible, setHasBeenVisible] = useState(false)

  useEffect(() => {
    if (isVisible && !hasBeenVisible) {
      // First time becoming visible
      setShow(true)
      setHasBeenVisible(true)
      
      const timer = setTimeout(() => {
        setShow(false)
        setTimeout(() => {
          onHide()
          setHasBeenVisible(false) // Reset for next time
        }, 300) // Wait for exit animation
      }, 2000) // Show for 2 seconds
      
      return () => clearTimeout(timer)
    } else if (!isVisible && hasBeenVisible) {
      // Force hide if parent says to hide
      setShow(false)
      setHasBeenVisible(false)
    }
  }, [isVisible, onHide, hasBeenVisible])

  const getIcon = () => {
    switch (type) {
      case 'points':
        return <Sparkles className="w-5 h-5" />
      case 'badge':
        return <Award className="w-5 h-5" />
      case 'achievement':
        return <Trophy className="w-5 h-5" />
      default:
        return <Star className="w-5 h-5" />
    }
  }

  const getBackground = () => {
    switch (type) {
      case 'points':
        return 'bg-green-500'
      case 'badge':
        return 'bg-purple-500'
      case 'achievement':
        return 'bg-yellow-500'
      default:
        return 'bg-blue-500'
    }
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -50, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -50, scale: 0.8 }}
          className={`${getBackground()} text-white px-6 py-4 rounded-xl shadow-lg flex items-center space-x-3`}
        >
          {getIcon()}
          <div>
            {points && <div className="font-bold">+{points} Points!</div>}
            <div className="text-sm opacity-90">{message}</div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Toast